import { type PatientStatus, PatientStatusEnum } from '@app/icare/entities/patient/schema/Patient'
import { Tag, type TagProps } from 'antd'
import type { ReactNode } from 'react'
import { FaEdit } from 'react-icons/fa'
import { twMerge } from 'tailwind-merge'

type PatientStatusValue = typeof PatientStatusEnum.$.Type

interface PatientStatusBadgeProps {
  value?: PatientStatusValue | PatientStatus | null
  className?: string
  children?: ReactNode
  style?: TagProps['style']
  onClick?: () => void
}

const resolveValue = (value: PatientStatusBadgeProps['value']): PatientStatusValue | undefined =>
  value == null ? undefined : typeof value === 'string' ? value : value.value

const getStatusColor = (status?: PatientStatusValue): TagProps['color'] => {
  switch (status) {
    case PatientStatusEnum.new:
      return 'blue'
    case PatientStatusEnum.open:
      return 'orange'
    case PatientStatusEnum.closed:
      return 'green'
    default:
      return 'default'
  }
}

const PatientStatusBadge = ({ value, children, onClick, className, style }: PatientStatusBadgeProps) => {
  const resolved = resolveValue(value)
  return (
    <Tag
      icon={onClick ? <FaEdit /> : undefined}
      color={getStatusColor(resolved)}
      variant="outlined"
      className={twMerge(onClick ? 'cursor-pointer flex! items-center gap-2 justify-center' : '', className)}
      style={style}
      onClick={onClick}
    >
      {children ?? (resolved ? PatientStatusEnum.$.getLabel(resolved) : '')}
    </Tag>
  )
}

export default PatientStatusBadge
